import Geofence from "./geofence";

export default Geofence;
